// Home Models
import { createHomeBannerStoreDefaultModel } from './banner/home-banner.store'
import { createHomeWelcomeStoreDefaultModel } from './welcome/home-welcome.store'
import { createHomeCertificationAgencyStoreDefaultModel } from './certification-agency/certification-agency.store'
import { createHomeNewsStoreDefaultModel } from './news/home-news.store'

const homeContentModels = {
  homeBanner: createHomeBannerStoreDefaultModel(),
  homeWelcome: createHomeWelcomeStoreDefaultModel(),
  homeCertificationAgency: createHomeCertificationAgencyStoreDefaultModel(),
  homeNews: createHomeNewsStoreDefaultModel(),
}

export { homeContentModels }
